import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {ContentDirective} from "../../../../shared/directives/content.directive";

@Component({
  selector: 'app-form-group',
  templateUrl: './form-group.component.html'
})
export class FormGroupComponent implements OnInit {

  @Input() title: string;
  @Input() value = '';
  @ContentChild(ContentDirective, { static: true, read: TemplateRef }) cardContentTpl: TemplateRef<any>;

  constructor() { }

  ngOnInit() {}

  get filterContentTplContext(): object {
    return { $implicit: this.value };
  }

}
